import React, { useMemo } from 'react'
import { makeStyles, Chip } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useFormattingContext } from '../FormattingProvider/FormattingContext'
import PanelTrigger from './PanelTrigger'

const useStyles = makeStyles((theme) => ({
  button: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  chip: {
    marginLeft: '10px',
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    height: '20px'
  }
}))

function DisplayName ({ className, item, parent }) {
  const { formatter } = useFormattingContext()
  const hasChildren = useMemo(() => item.items?.length > 0, [item])
  const itemFactor = useMemo(() => item.factors ? formatter(item.factors.value, item.factors.format) : null, [item, formatter])

  const classes = useStyles()

  if (item.threadKey) {
    return (
      <PanelTrigger
        className={clsx(className)}
        item={item}
        parent={parent}
        disabled={hasChildren}
      >
        {item.displayName}
        {itemFactor ? (
          <Chip className={classes.chip} size='small' label={itemFactor} />
        ) : null}
      </PanelTrigger>
    )
  }

  return (
    <div className={clsx(className)}>
      {item.displayName}
      {itemFactor ? (
        <Chip className={classes.chip} size='small' label={itemFactor} />
      ) : null}
    </div>
  )
}

DisplayName.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
  parent: PropTypes.any
}

export default React.memo(DisplayName)
